import { SmartLink } from "@selector/shared/components";
import { type FC } from "react";

import { type PlaybookEvent } from "../../../../graphql.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { getDateTimeItems } from "./core/DateCell.js";
import { TableCell } from "./core/TableCell.js";

const PlaybookEventTimestampCell: FC<IAgGridCellProps> = (props) => {
  if (props.data == null) {
    return null;
  }

  const playbookEvent = props.data as PlaybookEvent;
  const date = props.value;
  const dateAsString = getDateTimeItems(date, props.colDef);
  // take the first element as we do not have multi-values here
  const { value, tooltip } = { ...dateAsString[0] };

  return (
    <TableCell style={{ textAlign: "right" }}>
      <SmartLink to={`/event/${playbookEvent.id}`} tooltip={tooltip}>
        {value}
      </SmartLink>
    </TableCell>
  );
};

export default PlaybookEventTimestampCell;
